import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Radio: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 2.40039C4.90721 2.40039 2.40039 4.90721 2.40039 8C2.40039 11.0928 4.90721 13.5996 8 13.5996C11.0928 13.5996 13.5996 11.0928 13.5996 8C13.5996 4.90721 11.0928 2.40039 8 2.40039ZM8 4.5C9.933 4.5 11.5 6.067 11.5 8C11.5 9.933 9.933 11.5 8 11.5C6.067 11.5 4.5 9.933 4.5 8C4.5 6.067 6.067 4.5 8 4.5Z"
          fill="currentColor"
        />
      </svg>
    </IconWrap>
  );
};
Radio.displayName = 'Radio';

export default Radio;
